export const SELECT_LISTING = 'bulkInquiry/SELECT_LISTING'
export const DESELECT_LISTING = 'bulkInquiry/DESELECT_LISTING'
export const CLEAR_SELECTION = 'bulkInquiry/CLEAR_SELECTION'
export const SET_SELECT_MODE = 'bulkInquiry/SET_SELECT_MODE'
export const SET_FILTER_CONTEXT = 'bulkInquiry/SET_FILTER_CONTEXT'
